<template>
  <div>
    <div class="breadcrumbs">
        <div class="container">
            <div class="breadcrumbs__list">
                <router-link to="/" class="breadcrumbs__item">Home</router-link>
                <router-link to="/news" class="breadcrumbs__item">News</router-link>
                <div class="breadcrumbs__item breadcrumbs__item--active">{{ article.title }}</div>
            </div>
        </div>
    </div>

    <div class="news">
        <div class="container">
            <div class="news__body">
                <main class="news__content">
                    <article class="news__article">
                        <h1 class="news__article__title">{{ article.title }}</h1>
                        <div class="news__article__head">
                            <div class="news__article__head__date">PUBLISHED ON {{ article.date }}</div>
                            <!--<div class="news__article__head__socials">
                                <div class="news__article__head__socials__fb">
                                    <div class="fb-like" data-href="https://developers.facebook.com/docs/plugins/" data-layout="button" data-action="like" data-size="small" data-show-faces="true" data-share="true"></div>
                                </div>
                                <div class="news__article__head__socials__tw">
                                    <a class="twitter-share-button" href="https://twitter.com/intent/tweet?text=Test">Tweet</a>
                                </div>
                            </div> -->
                        </div>
                        <div v-if="article.img" class="news__article__preview">
                            <img v-bind:src="article.img" :alt="article.title" class="news__article__preview__img">
                        </div>
                        <div class="news__article__content" v-html="article.content"></div>
                    </article>
                </main>
                <aside class="news__sidebar">
                    <div class="banner">
                        <h2 class="banner__title">EASY TO START</h2>
                        <h3 class="banner__sub-title">with AdOperator</h3>
                        <p class="banner__desc">Create an account at ADOP system and start your campaign with any budget!</p>

                        <div class="banner__controls">
                            <router-link to="/signup" class="button button--rounded button--wshadow button--secondary">create an account</router-link>
                        </div>
                    </div>

                    <div class="subscribe-form">
                        <div class="subscribe-form__preview">
                            <img src="/static/img/mailbox.svg" alt="mailbox" class="subscribe-form__preview__img">
                        </div>

                        <h3 class="subscribe-form__title">Don't miss updates from us!</h3>
                        <p class="subscribe-form__desc">Subscribe for our newsletters. Be in touch with ADOP news</p>

                        <form class="subscribe-form__body">
                            <div class="subscribe-form__body__input">
                                <input type="text" class="input-default input-default--rounded input-default--small" placeholder="Enter your email address">
                            </div>
                            <div class="subscribe-form__body__controls">
                                <button class="button button--rounded button--primary">Subscribe</button>
                            </div>
                        </form>
                    </div>
                </aside>
            </div>
        </div>
    </div>

    <div class="news-related">
        <div class="container">
            <div class="news-related__body">
                <div class="news-related__head">
                    <h2 class="news-related__title">Related articles </h2>

                    <!--<div class="news-related__head__controls">
                        <a href="#" class="button button--rounded button--small button--primary-otln">View All</a>
                    </div>-->
                </div>
                <div class="news-related__list">
                    <div class="news-related__list__body">
                        <a v-bind:href="item.slug" class="news-item" v-for="item in news" :key="item.slug">
                            <div v-if="item.img" class="news-item__preview">
                                <img v-bind:src="item.img" :alt="item.title.rendered" class="news-item__preview__img">
                            </div>
                            <h3 class="news-item__title">{{ item.title.rendered }}</h3>
                            <p class="news-item__desc" v-html="item.excerpt.rendered"></p>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import wp from '@/utils/wp'

export default {
  name: 'NewsItem',
  data () {
    return {
      news: [],
      article: {}
    }
  },
  head: {
    title: function () {
      return {
        inner: this.article.title,
        separator: '-',
        complement: 'Ad Operator'
      }
    },
    meta: function () {
      return [
        {
          name: 'description',
          content: this.article.textContent
        },
        {
          name: 'keywords',
          content: 'news'
        },
        {
          property: 'og:title',
          content: this.article.title
        },
        {
          property: 'og:image',
          content: this.article.img || 'https://adop.co/static/favicon/android-icon-192x192.png'
        },
        {
          property: 'og:url',
          content: 'https://adop.co/' + this.article.slug
        },
        {
          property: 'og:description',
          content: this.article.textContent
        }
      ]
    },
    link: function () {
      return [
        {
          rel: 'canonical',
          h: 'https://adop.co/' + this.article.slug,
          id: 'canonical'
        }
      ]
    }
  },
  mounted () {
    wp({type: 'post', data: {slug: this.$route.params.slug}})
      .then(resp => {
        this.article = resp

        let div = document.createElement('div')
        div.innerHTML = this.article.content
        this.article.textContent = (div.textContent || div.innerText || '').trim()

        if (this.$route.params.slug !== this.article.slug) {
          this.$router.push('/news/' + this.article.slug)
        }

        this.$emit('updateHead') // обновление для мета
      }).catch(e => {
        this.$router.push({name: 'PageNotFound'})
      })
    wp({type: 'posts', data: {per_page: 4}})
      .then(resp => {
        this.news = resp
      })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/front/news/item.vue